import { AxiosRequestConfig } from "axios";
import useAxios, { Options } from "axios-hooks";
import { useEffect, useState } from "react";

export function useAxiosFetchMultiple<TItem = any, TResponse = any, TBody = any, TError = any>(
  axios: {
    config: AxiosRequestConfig<any>,
    options?: Options,
  },
  search_func: (from: number, to: number) => any,
  count_func: (data: TResponse) => number,
  item_func: (date: TResponse) => TItem[],
  deps_func: (config: AxiosRequestConfig<any>) => [boolean, any[]],
  by: number = 100,
) {
  const [totalCount, setTotalCount] = useState<number | undefined>();
  const [page, setPage] = useState(0);
  const [items, setItems] = useState<TItem[]>([]);

  const from = page * by, to = (page + 1) * by;
  const config = { ...axios.config, params: { ...axios.config.params, ...search_func(from, to) } }

  let [shouldRefetch, deps] = deps_func(config);

  const options = { ...axios.options, manual: !shouldRefetch }

  const [{ data, loading, error }, refetch] = useAxios<TResponse, TBody, TError>(config, options);

  useEffect(() => {
    if (!data) return;

    if (totalCount === undefined) setTotalCount(count_func(data));

    const newItems = [...items, ...item_func(data)];
    setItems(newItems);

    if (totalCount === undefined || totalCount > newItems.length) {
      setPage(page + 1);
      refetch();
    }
  }, [data]);

  useEffect(() => {
    setTotalCount(undefined);
    setPage(0);
    setItems([]);
    shouldRefetch && refetch();
  }, [...deps])

  return { data: items, loading: loading || (!error && (totalCount === undefined || totalCount > items.length)), error }
}
